import React, { ComponentType } from 'react'
import Loader from 'components/common/loader'
import useFirebase from 'core/services/firebase/useFirebase'

const withFirebase = (ComposedComponent: ComponentType<any>, loader: React.ReactNode = <Loader />) => {
    const WithFirebase: React.FC<any> = ({ ...props }) => {
        useFirebase()
        return <ComposedComponent {...props} />
    }
    return WithFirebase
}

export default withFirebase
